import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { GoodsReceivingService } from '../../../services/goods-receiving/goods-receiving.service';
import type { IGoodsReceivingService } from '../../../services/goods-receiving/goods-receiving.types';
import { goodsReceivingQueryKeys } from '../query-keys';

/**
 * Hook to fetch recall matches for a DRAFT delivery note.
 * Enabled only when a draft exists and has at least one item.
 */
export function useDraftRecallMatches(draftId: string | null | undefined, itemCount: number) {
  const service = useInjection<IGoodsReceivingService>(GoodsReceivingService);

  return useQuery({
    queryKey: goodsReceivingQueryKeys.recallMatches(draftId ?? '', itemCount),
    queryFn: () => {
      if (!draftId) {
        throw new Error('draftId is required for recall check');
      }
      return service.checkRecalls(draftId);
    },
    enabled: Boolean(draftId) && itemCount > 0,
    staleTime: 30_000,
  });
}
